import { useState } from 'react';
import KeyValuePair from 'shared/models/key-value-pair';

export type FilterChipProps = {
  options: KeyValuePair[];
  onOptionSelected: (key?: string) => void;
  placeHolder: string;
  initialSelectedOption?: KeyValuePair;
  disabled?: boolean;
};

type FilterChip = {
  isOpen: boolean;
  close: () => void;
  toggleIsOpen: () => void;
  handleOnMenuItemClicked: (key: string, value: string) => void;
  chipLabel: string;
  chipActive: boolean;
  options: KeyValuePair[];
  initialSelectedOption: KeyValuePair | undefined;
};

export const useFilterChip = ({ options, onOptionSelected, placeHolder, initialSelectedOption }: Readonly<FilterChipProps>): FilterChip => {
  const [isOpen, setIsOpen] = useState(false);

  const close = (): void => setIsOpen(false);
  const toggleIsOpen = (): void => setIsOpen((prev) => !prev);

  const handleOnMenuItemClicked = (key: string): void => {
    setIsOpen(false);
    onOptionSelected(key === initialSelectedOption?.key ? undefined : key);
  };

  const chipLabel = initialSelectedOption?.value ?? placeHolder;
  const chipActive = initialSelectedOption?.key !== undefined;

  return {
    isOpen,
    close,
    toggleIsOpen,
    handleOnMenuItemClicked,
    chipLabel,
    chipActive,
    options,
    initialSelectedOption,
  };
};
